export default "/images/a35903f59c5d41aa6275f304d8f94767.avif";